import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { Award } from '../awards-view.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, accAreaService: AcceleratorAreaService): GridSetup<Award> {

	return {
		rowName: { singular: 'Award', plural: 'Awards' },
		getRowKey: row => '' + row.awardId,
		stateKey: 'accelerator-awards-grid',
		actions: getActions(dialogService, accAreaService),
		buttons: getButtons(dialogService, accAreaService),
		columns: getColumns(util),
	}
}
